import { Button } from '@/components/feature/HealthClaimDetailPage/styles'
import message from '@/libs/message'
import { fetchRejectDocument } from '@/services/healthClaim/useRejectDocument'
import PreviewPdfModal from '../../HealthClaimPage/ClaimHandlingTable/components/PreviewPdfModal'
import { useState } from 'react'

function ViewRejectDocumentButton({
  claimFormId,
  hasRejectDocument,
}: {
  claimFormId?: string
  hasRejectDocument: boolean
}) {
  const [documentUrl, setDocumentUrl] = useState<string | null>(null)
  return (
    <>
      {hasRejectDocument && (
        <Button
          onClick={() => {
            if (!claimFormId) return
            fetchRejectDocument(claimFormId)
              .then((documents) => {
                if (typeof documents === 'string' && documents.startsWith('http')) {
                  return setDocumentUrl(documents)
                }
              })
              .catch((error) => {
                message.error({
                  content: 'error',
                  duration: 10,
                })
              })
          }}
        >
          ดูเอกสารปฏิเสธคำขอ
        </Button>
      )}
      {documentUrl && (
        <PreviewPdfModal
          pdf={documentUrl}
          onCancel={() => {
            setDocumentUrl(null)
          }}
          visible={!!documentUrl}
        />
      )}
    </>
  )
}

export default ViewRejectDocumentButton
